import React from 'react';
import Footer from '../Shared/Footer/Footer';
import NavBar2 from '../Shared/NavBar2/NavBar2';
import './Pages.css'
const ContactUs = () => {
    return (
        <div >
            <NavBar2 />
            <div className="contact margin">
                <div className="about1">
                    <h2 className="text-dark">Contact Us</h2>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <h4>Our Company</h4>
                        <p>We are a bajery,only confectionary-based in New york,operating from a commercial space.</p> <br />
                        <div className="row">
                            <div className="col-lg-6">
                                <small>New york</small> <br />
                                <small>198 West 21th Street,Suite 721 New york NY 11001</small>
                                <br /> <br />
                                <small><b>Email:</b>carame@gmail.com</small> <br />
                                <small><b>Phone:</b>+880564568</small>
                            </div>
                            <div className="col-lg-6">
                                <small>Paris</small> <br />
                                <small>198 West 21th Street,Suite 721 Paris NY 11001</small>
                                <br /> <br />
                                <small><b>Email:</b>carame@gmail.com</small> <br />
                                <small><b>Phone:</b>+880564568</small>
                            </div>
                        </div>

                    </div>

                    <div className="col-lg-6">

                        <form id="contactForm" data-sb-form-api-token="API_TOKEN">

                            {/* <!-- Name Input --> */}
                            <div class="form-floating mb-3">
                                <input class="form-control" id="name" type="text" placeholder="Name" data-sb-validations="required" />
                                <label for="name">Name</label>
                                <div class="invalid-feedback" data-sb-feedback="name:required">Name is required.</div>
                            </div>

                            {/* <!-- Email Input --> */}
                            <div class="form-floating mb-3">
                                <input class="form-control" id="emailAddress" type="email" placeholder="Email Address" data-sb-validations="required,email" />
                                <label for="emailAddress">Email Address</label>
                                <div class="invalid-feedback" data-sb-feedback="emailAddress:required">Email Address is required.</div>
                                <div class="invalid-feedback" data-sb-feedback="emailAddress:email">Email Address Email is not valid.</div>
                            </div>

                            {/* <!-- Message Input --> */}
                            <div class="form-floating mb-3">
                                <textarea class="form-control" id="message" type="text" placeholder="Message" style={{ height: "10rem" }} data-sb-validations="required"></textarea>
                                <label for="message">Message</label>
                                <div class="invalid-feedback" data-sb-feedback="message:required">Message is required.</div>
                            </div>

                            {/* <!-- Submit success message --> */}
                            <div class="d-none" id="submitSuccessMessage">
                                <div class="text-center mb-3">
                                    <div class="fw-bolder">Form submission successful!</div>
                                    <p>To activate this form, sign up at</p>
                                    <a href="https://startbootstrap.com/solution/contact-forms">https://startbootstrap.com/solution/contact-forms</a>
                                </div>
                            </div>

                            {/* <!-- Submit error message --> */}
                            <div class="d-none" id="submitErrorMessage">
                                <div class="text-center text-danger mb-3">Error sending message!</div>
                            </div>

                            {/* <!-- Submit button --> */}
                            <div class="d-grid">
                                <button class="btn btn-primary btn-lg " id="submitButton" type="submit">Submit</button>
                            </div>
                        </form>
                    </div>


                </div>
            </div>
            {/* map */}
            <div class="mapouter mt-5"><div class="gmap_canvas"><iframe width="100%" height="510" id="gmap_canvas" src="https://maps.google.com/maps?q=california&t=&z=10&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                <a href="https://2yu.co">2yu</a>
                <a href="https://embedgooglemap.2yu.co">html embed google map</a></div></div>
            <Footer />
        </div>
    );
};

export default ContactUs;